import { useEliteOnboardingAdvisoryStatus } from '../../hooks/useEliteOnboardingAdvisoryStatus'
import { NewEliteLandingAnalyticsScreen } from '../../analytics/newEliteLandingAnalytics'
import NewEliteLandingPage from '../NewEliteLandingPage'
import { buildFamilyOnboardingViewProps } from './familyOnboardingViewProps'

export default function NewEliteFamilyLandingPage() {
  const { data } = useEliteOnboardingAdvisoryStatus('NEW_ELITE_ONBOARDING_ADVISORY_STATUS')
  const familyConfig = buildFamilyOnboardingViewProps(data)

  return (
    <NewEliteLandingPage
      familyConfig={familyConfig}
      analyticsScreen={NewEliteLandingAnalyticsScreen.FamilyLanding}
    />
  )
}